import React from 'react';
import { Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

export default function StandaloneMobileHeader({ show, brandNode, menuOpen, onOpenMenu, themeTokens }) {
  if (!show) return null;
  return (
    <header
      className="flare-standalone-mobile-header"
      style={{
        alignItems: 'center',
        background: themeTokens.surfaceBg,
        borderBottom: `1px solid ${themeTokens.divider}`,
        display: 'flex',
        gap: 8,
        minWidth: 0,
        padding: 'calc(env(safe-area-inset-top, 0px) + 4px) max(12px, env(safe-area-inset-right, 0px)) 4px max(12px, env(safe-area-inset-left, 0px))',
      }}
    >
      <Button
        aria-label="打开会话侧栏"
        aria-expanded={menuOpen}
        icon={<MenuOutlined />}
        onClick={onOpenMenu}
        style={{ color: themeTokens.textPrimary, flex: '0 0 auto', height: 44, width: 44 }}
        type="text"
      />
      <div style={{ minWidth: 0, overflow: 'hidden' }}>{brandNode}</div>
    </header>
  );
}
